import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    // only honoured for admins, everybody else gets the own corporation
    corporationId?: string;
};

export const schemaUserResolver_GetAdvisersByCorporation = z.array(
    UsersTableDefinitionZod.pick({
        deactivated: true,
        firstName: true,
        id: true,
        lastName: true,
        role: true,
    }),
);

export type SchemaUserResolver_GetAdvisersByCorporation = z.infer<typeof schemaUserResolver_GetAdvisersByCorporation>;

export type UserResolver_GetAdvisersByCorporation = Resolver<Arguments, SchemaUserResolver_GetAdvisersByCorporation>;
